import { z } from 'zod';
import { SUPPORTED_LANGUAGES } from './constants';

export const languageSchema = z.enum(SUPPORTED_LANGUAGES);

export type LanguageCode = z.infer<typeof languageSchema>;

export const userPreferencesSchema = z.object({
  language: languageSchema.optional(),
  timezone: z.string().optional(),
});
